import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import Image from 'ui/src/components/Image';
import useFooterThemes from './themes';

type LogoFooterProps = {
  logoPath: string;
  logoSize: [number, number];
  containerClasses?: string;
};

export default function LogoFooter({ logoPath, logoSize, containerClasses }: LogoFooterProps) {
  const { footerLogoClasses } = useFooterThemes();

  return (
    <div className={twMerge(footerLogoClasses, containerClasses)}>
      <Image src={logoPath} alt="BairesDev Logo" width={logoSize[0]} height={logoSize[1]} />
    </div>
  );
}
